import React, { useEffect, useRef} from 'react';
import { ITerraceSummaryStation, TerraceSummaryVM } from './TerraceSummaryVM';
import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu';
import { ActionsMenu } from '../../common/ActionsMenu'; 
import { DesignSummaryButtons } from '../../common/DesignSummaryButtons'; 
import { StaticTooltip } from 'cd-eft/components/common/StaticTooltip/StaticTooltip'; 
import { DropdownPopover } from 'cd-eft/components/common/DropdownPopover/DropdownPopover'; 
import { Table, Modal, ModalHeader, ModalBody, ModalFooter, Container } from 'reactstrap';
import { observer } from 'mobx-react'; 
import './TerraceSummary.scss';
import { LoaderWithBar } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { formatDateShort } from 'cd-eft/utils/formatDate';
import { mdiHelpCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useHistory } from 'react-router-dom';
import stores from 'cd-eft/models/Stores';
import { PopupContainer } from '../../common/SummaryDetails/SDetails';

const { designStore, terraceDesignStore } = stores.AppStore;

const TerraceSummaryComponent = () => {
  const history = useHistory()
  const vm = useRef(new TerraceSummaryVM(history)).current;
  
  useEffect(()=>{
    vm.init();
    vm.combinedLoad();
    return () => {
      designStore.setLoader('');
    };
  },[])

  const tooltipStandardMessage =
  'Data invalid for the listed items below. Input changes detected. Please Edit and recalculate.';

  const Cols =
    [
      { name: "select", title: "Select"},
      { name: "name", title: "Name"},
      { name: "terraceType", title: "Terrace Type"},
      { name: "defaultTemplate", title: "Default Template"},
      { name: "length", title: "Length"},
      { name: "maxHeight", title: "Max Height"},
      {
        name: 'warnings',
        title: 'Warnings',
        enableTooltip: true
      },
      { name: "createdDate", title: "Date Created"},
      { name: "lastUpdatedDate", title: "Last Updated"},
      { name: "actions", title: "Actions"},
    ];

  return (
    <>
    <TerraceLoaderContainer />
    <div className="terrace-summary">
      <CollapseMenu
      title = {"Terrace Design Summary"}
      className={`designelement-container`}
      noIcon = {true}
      forceOpen = {true}>
        <h2 className='summary-title'><strong>Summary</strong></h2>
        <div className="design-summary-table">
          <Table className="set-table">
            <thead className="table-header">
              <tr>
                {Cols.map((e, index) => (
                  <th key={'key-terraceSummary-title' + index} className={e.name === 'warnings' ? 'tooltip-header' : ''}>
                    <span>
                      {e.title}&nbsp;
                      {e.enableTooltip && vm.showIcon
                        ? <StaticTooltip tooltipMessage={tooltipStandardMessage} tooltipSide="bottom" id="terrace-warnings-tooltip" title="Warnings info" />
                        : null}
                      </span>
                  </th>
                ))}
              </tr>
            </thead>
            {vm.TerraceSummaryStationList.length > 0 ? (
              <tbody>
                {vm.TerraceSummaryStationList.map((e:ITerraceSummaryStation, index:number) => (
                  <tr key={'key-TerraceSummary-' + index} className={terraceDesignStore.newTerraces.includes(e.alignedDesignElementId) ? "highlightedRow" : ""}>
                    <td>
                      <input
                      id={'select' + index}
                      name="select"
                      type="checkbox"
                      checked={vm.TerraceSummaryStationList[index].select}
                      onChange={()=>{vm.handleCheckboxChange(index)}}
                      disabled={false}
                      aria-label={`select-${e.name}`}
                      />
                    </td>
                    <td>
                      {e.name}
                    </td>
                    <td>
                        {e.terraceType}
                    </td>
                    <td>
                      {e.defaultTemplate ? e.defaultTemplate : 'None'}
                    </td>
                    <td>
                      {e.length}
                    </td>
                    <td>
                      {e.maxHeight}
                    </td>
                    <td className="list-text">
                      {vm.notificationStatusOR(e.alignedDesignElementId) ?
                        <NotificationBlock vm={vm} element={e}/>
                      :"None"}
                    </td>
                    <td>
                      {e.createdDate ? formatDateShort(e.createdDate) : ''}
                    </td>
                    <td>
                      {formatDateShort(e.lastUpdated)}
                    </td>
                    <td>
                      <ActionsMenu i={index} item={e} elementActions={vm.elementActions} />
                    </td>
                  </tr>
                ))}
              </tbody>
            ):null}
          </Table>
          {vm.TerraceSummaryStationList.length === 0 ? (
            <h3 className="h4 note-summary">Add your first Terrace</h3>
          ) : null}
        </div>
        <DesignSummaryButtons
          panel="Terrace"
          disableAdd={false}
          buttontype={false}
          add={vm.newTerraceProject}
          refreshElements={vm.refreshElements}
          rebuildSurface={vm.callRebuildSurface}
          disableRefreshElements={vm.TerraceSummaryStationList.length === 0}
          disableRebuildSurface={vm.TerraceSummaryStationList.length === 0}
        /> 
        
        {vm.onClickInformation ? (
          <div>
            <Modal
            isOpen={vm.onClickInformation}
            toggle={vm.onClickInformationToggle}
            centered={true}
            className="eft-action-modal"
            aria-label={vm.headerTitle}
            >
              <ModalHeader toggle= {vm.onClickInformationToggle} className='header-info-detail'>
                <div className="display-flex flex-align-center">
                  <strong>{`Information Details on ${vm.headerTitle}`}</strong> 
                </div>
                <a className="href-info-detail" href="/design/terracesummarydetails" target="_blank">
                  <strong>Open Information in a New Window</strong>
                </a>
              </ModalHeader>
              <ModalBody>
                <Container>
                  {PopupContainer({title: vm.headerTitle, design: 3})}
                </Container>
              </ModalBody>
              <ModalFooter>
                <button className="usa-button usa-button--outline" onClick={vm.onClickInformationToggle}>
                  Close
                </button>
              </ModalFooter>
            </Modal>
          </div>
        ) : null }
        </ CollapseMenu>
        </div>
      </>
  );
};

export const TerraceSummary = observer(TerraceSummaryComponent);

// Add the TerraceLoaderContainer component
const TerraceLoaderContainer = observer(() => {
  return (
    <>
      {designStore.isLoading && (
        <LoaderWithBar
          message={designStore.loadingMsg}
          className={'design-container-loader terrace-loader'}
          processName={designStore.processName}
          loadingProgress={designStore.loadingProgress}
          loading={designStore.isLoading}
        />
      )}
    </>
  );
});

interface INotificationBlockProps {
  vm: TerraceSummaryVM;
  element;
}
interface INotifictionEntryProps {
  vm: TerraceSummaryVM;
  section: string;
}
const NotificationEntry = (props: INotifictionEntryProps) => {
  return (
  <li className='list-content'>
    <span className='text'>{props.section}</span> 
    <button className="question-button" title={props.section} onClick={() => props.vm.onClickInformationToggle(props.section)}>
      <Icon className='help-icon' path={mdiHelpCircleOutline} size={1} /> 
    </button>
  </li>
  )
}

const NotificationBlock = (props: INotificationBlockProps) => {
  const { vm, element } = props;

  return (
    <DropdownPopover buttonText="View List">
      <ul className="add-list-reset">
        {vm.notificationDictionary[element.alignedDesignElementId]?.surface !== 0 ?
          <NotificationEntry vm={vm} section='Surface' /> : null}
        {vm.notificationDictionary[element.alignedDesignElementId]?.alignment !== 0 ?
          <NotificationEntry vm={vm} section='Alignment' /> : null}
        {vm.notificationDictionary[element.alignedDesignElementId]?.hydrology !== 0 ?
          <NotificationEntry vm={vm} section='Hydrology' /> : null}
        {vm.notificationDictionary[element.alignedDesignElementId]?.designControl !== 0 ?
          <NotificationEntry vm={vm} section='Design Controls' /> : null}
        {vm.notificationDictionary[element.alignedDesignElementId]?.reaches !== 0 ?
          <NotificationEntry vm={vm} section='Reaches' /> : null}
      </ul>
    </DropdownPopover>
  )
}